// Webinar Grid: category filter tags (including "Upcoming (Live)") show/hide cards client-side;
// "Learn more" reveals the rest (mechanics in filterGrid.js).
import initFilterGrid from './filterGrid';

export default function initWebinarGrid() {
  initFilterGrid({
    rootSelector: '.section-webinar-grid',
    tagSelector: '.section-webinar-grid__filter-tag',
    itemSelector: '.section-webinar-grid__card',
    moreSelector: '.section-webinar-grid__more',
    emptyText: (label) => 'No webinars under \u201C' + label + '\u201D right now. Our speakers are busy making the next one \u2014 try \u201CAll webinars\u201D for the recordings.',
  });
}
